import React from "react";

const AuthContainerPage = ({ children }) => {
  return <div className="">{children}</div>;
};

export default AuthContainerPage;
